module.exports = __webpack_public_path__ + "img/intelli.ed2276be.png";